/* assets/trepsa-step-exit.js — Schritt 6: Treppenaustritt (variantenbasiert nach Breite) */
(() => {
  "use strict";

  function esc(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;").replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;").replaceAll('"', "&quot;");
  }

  function centsToEUR(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n) || n <= 0) return null;
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n / 100);
  }

  function parseTitleNums(title) {
    const nums = String(title || "").match(/\d+/g);
    return nums ? nums.map(Number) : [];
  }

  function init() {
    const root = document.querySelector("[data-trepsa-exit]");
    if (!root) return;

    // Varianten laden + nach Breite (erste Zahl im Titel) sortieren
    let exitCfg = { title: "", variants: [] };
    try {
      exitCfg = JSON.parse(root.querySelector("[data-exit-config]")?.textContent || "{}") || {};
    } catch { exitCfg = { title: "", variants: [] }; }

    const available = (Array.isArray(exitCfg.variants) ? exitCfg.variants : [])
      .filter(v => v && v.available && v.id)
      .map(v => ({ breite: parseTitleNums(v.title)[0] || 0, id: v.id, price: Number(v.price || 0), title: v.title }))
      .filter(v => v.breite > 0)
      .sort((a, b) => a.breite - b.breite);

    const maxBreite = available.length ? available[available.length - 1].breite : 0;

    const exitsWrap  = root.querySelector("[data-exit-list]");
    const addExitBtn = root.querySelector("[data-exit-add]");

    const digits = (raw) => String(raw || "").replace(/[^\d]/g, "");

    function newExit() { return { width: "", count: 1 }; }
    const state = { exits: [newExit()] };

    // Passende Variante = nächstgrößere Breite
    function matchVariant(widthMM) {
      if (!widthMM || !available.length) return null;
      return available.find(v => v.breite >= widthMM) || null;
    }

    function exitError(e) {
      const w = Number(e.width);
      if (!e.width) return null;
      if (w <= 0) return "Bitte eine gültige Breite eingeben.";
      if (maxBreite && w > maxBreite) return `Breite ${w} mm überschreitet das Maximum von ${maxBreite} mm.`;
      if (!matchVariant(w)) return `Keine passende Variante für ${w} mm.`;
      return null;
    }

    function exitHTML(e, i) {
      const err = exitError(e);
      const canDel = state.exits.length > 1;
      const v = matchVariant(Number(e.width));
      const priceLbl = (v && !err) ? centsToEUR(v.price * (Number(e.count) || 1)) : "";
      return `
        <div class="trepsa-s4__entry" data-exit-index="${i}">
          <div class="trepsa-s4__entryHead">
            <span class="trepsa-s4__entryTitle">Treppenaustritt ${i + 1}${priceLbl ? ` <em style="font-weight:700;opacity:.6;">${esc(priceLbl)}</em>` : ""}</span>
            ${canDel ? `<button class="trepsa-s4__delBtn" type="button" data-exit-del="${i}">Löschen</button>` : ""}
          </div>
          <div class="trepsa-s4__fieldRow">
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Anzahl</label>
              <input class="trepsa-s4__input" type="text" inputmode="numeric" pattern="[0-9]*"
                placeholder="1" data-exit-input="count" value="${esc(String(e.count || 1))}">
            </div>
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Breite des Profils (mm)</label>
              <input class="trepsa-s4__input ${err ? "is-error" : ""}" type="text"
                inputmode="numeric" pattern="[0-9]*" placeholder="z.B. 900"
                data-exit-input="width" value="${esc(e.width)}">
            </div>
          </div>
          ${err ? `<div class="trepsa-s4__inlineError">${esc(err)}</div>` : ""}
        </div>`;
    }
    function renderExits() { if (exitsWrap) exitsWrap.innerHTML = state.exits.map(exitHTML).join(""); }

    function emit() {
      // Nur gültige Austritte mit gematchter Variante
      const valid = state.exits
        .filter(e => e.width && !exitError(e))
        .map(e => {
          const v = matchVariant(Number(e.width));
          return v ? { width: e.width, count: Number(e.count) || 1, variantId: v.id, matchedTitle: v.title, price: v.price } : null;
        })
        .filter(Boolean);

      // Preissumme über alle Austritte (Variante × Anzahl)
      let priceCents = 0;
      for (const e of valid) priceCents += e.price * e.count;

      window.dispatchEvent(new CustomEvent("trepsa:exit:update", {
        detail: {
          exits: valid.map(e => ({ width: e.width, count: e.count, variantId: e.variantId, matchedTitle: e.matchedTitle })),
          priceCents,
        }
      }));
    }

    function saveState() {
      try {
        localStorage.setItem("trepsa_exit", JSON.stringify({
          exits: state.exits.map(e => ({ width: e.width, count: e.count }))
        }));
      } catch (_) {}
    }

    function refresh() { emit(); saveState(); }

    addExitBtn?.addEventListener("click", () => {
      state.exits.push(newExit());
      renderExits();
      refresh();
    });

    root.addEventListener("click", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const del = t?.closest("[data-exit-del]");
      if (del) {
        const i = Number(del.getAttribute("data-exit-del"));
        if (state.exits.length > 1) { state.exits.splice(i, 1); renderExits(); refresh(); }
      }
    });

    root.addEventListener("input", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest("[data-exit-input]");
      if (!input) return;
      const idx = Number(t.closest("[data-exit-index]")?.getAttribute("data-exit-index"));
      const key = input.getAttribute("data-exit-input");
      const s   = state.exits[idx];
      if (!s) return;
      const clean = digits(t.value);
      if (key === "count") {
        if (clean === "") { s.count = ""; t.value = ""; refresh(); return; }
        s.count = Math.max(1, Math.min(99, Number(clean) || 1));
        t.value = s.count;
        // Preis-Label aktualisieren
        const card = t.closest("[data-exit-index]");
        const v = matchVariant(Number(s.width));
        const err = exitError(s);
        const priceLbl = (v && !err) ? centsToEUR(v.price * (Number(s.count) || 1)) : "";
        const titleEl = card?.querySelector(".trepsa-s4__entryTitle");
        if (titleEl) titleEl.innerHTML = `Treppenaustritt ${idx + 1}${priceLbl ? ` <em style="font-weight:700;opacity:.6;">${esc(priceLbl)}</em>` : ""}`;
        refresh();
        return;
      } else {
        s[key] = clean;
        t.value = clean;
      }
      const card = t.closest("[data-exit-index]");
      const err  = exitError(s);
      card?.querySelectorAll(".trepsa-s4__inlineError").forEach(el => el.remove());
      if (err) card?.insertAdjacentHTML("beforeend", `<div class="trepsa-s4__inlineError">${esc(err)}</div>`);
      card?.querySelector(`[data-exit-input="width"]`)?.classList.toggle("is-error", !!err);
      // Preis-Label aktualisieren
      const v = matchVariant(Number(s.width));
      const priceLbl = (v && !err) ? centsToEUR(v.price * (Number(s.count) || 1)) : "";
      const titleEl = card?.querySelector(".trepsa-s4__entryTitle");
      if (titleEl) titleEl.innerHTML = `Treppenaustritt ${idx + 1}${priceLbl ? ` <em style="font-weight:700;opacity:.6;">${esc(priceLbl)}</em>` : ""}`;
      refresh();
    });

    root.addEventListener("focusout", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest('[data-exit-input="count"]');
      if (!input) return;
      const idx = Number(t.closest("[data-exit-index]")?.getAttribute("data-exit-index"));
      const s = state.exits[idx];
      if (s && (s.count === "" || !Number(s.count))) {
        s.count = 1;
        input.value = "1";
        refresh();
      }
    });

    // Gespeicherten Zustand wiederherstellen
    (function restore() {
      try {
        const saved = JSON.parse(localStorage.getItem("trepsa_exit") || "null");
        if (saved && Array.isArray(saved.exits) && saved.exits.length) {
          state.exits = saved.exits.map(e => ({ width: String(e.width || ""), count: Number(e.count) || 1 }));
        }
      } catch (_) {}
    })();

    renderExits();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();